<template>
  <!-- Loading Modal -->
  <div class="modal-mydata-tailored" v-show="modal_message.showModalTailored">
    <div class="inside-modal-edit-company">
      <!-- Logo -->
      <div class="row f-row text-center">
        <div class="col col-12 mt-2">
          <img
            :src="logo"
            @mouseover="logo = logo_blue"
            @mouseout="logo = logo_white"
            height="30"
            alt=""
            style="padding: 0"
          />
        </div>
      </div>
      <div
        class="row f-row text-center"
        style="border-bottom: 1px solid var(--graylightbackground) !important;"
      >
        <div class="col col-12 mt-1">
          CUSTOMIZE HEDGING PERCENTAGES
        </div>
      </div>
      <!-- ============= form =============  -->
      <div class="row f-row justify-content-center">
        <div class="col col-8">
          <form>
            <!-- @submit.prevent="validateBeforeSubmit">-->
            <table class="table table-borderless table-sm mt-2">
              <thead class="table-headers text-center align-center thead">
                <tr style="border-bottom: 1px solid var(--graylightbackground)">
                  <th width="40%">{{ columnName }}</th>
                  <th width="40%">EXAMPLE DATE</th>
                  <th width="40%">{{ percentTitle }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in exampleDataFiltered"
                  :key="index"
                  class="tr"
                >
                  <td class="text-center">{{ index }}</td>
                  <td class="text-center">{{ item.date | formatDate }}</td>
                  <td class="text-center">
                    <input
                      style="width: 50%!important"
                      class="custom-input"
                      v-model.number="item.percentage"
                      @change="onUserPercChange(item)"
                    />%
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="text-center">
                    {{ (hedgeTotal / expoTotal) | percentageFormat }}
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- ============= Buttons =============  -->
            <div class="row f-row">
              <div
                class="col col-6 text-right align-right mt-2"
                style="padding-right: 5px;"
              >
                <button
                  v-on:click="
                    modal_message.showModalTailored = !modal_message.showModalTailored
                  "
                  type="button"
                  class="btn btn-sm btn-home"
                >
                  Cancel
                </button>
              </div>
              <div
                class="col col-6 text-left align-left mt-2"
                style="padding-left: 5px;"
              >
                <button
                  v-on:click="onUserAccept"
                  type="button"
                  class="btn btn-sm btn-home"
                >
                  Accept
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { format } from "d3";

export default {
  name: "ProgramTaylorMade",
  components: {},
  props: {
    exampleData: { required: true },
    modal_message: { required: true },
    watcherTaylorMade: { required: true },
  },
  data() {
    return {
      expoTotal: 0,
      hedgeTotal: 0,
      exampleDataFiltered: [],
      localexampleData: [],
      columnName: "",
      percentTitle: "",
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      showLoading: false,
    };
  },
  created() {},
  mounted() {},
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("MMM YYYY");
      }
    },
    percentageFormat: function(val) {
      return format(",.1%")(val);
    },
  },
  watch: {
    watcherTaylorMade() {
      this.calculateExpo();
      this.exampleDataFiltered = this.exampleData;
      this.createPercentages();
    },
  },
  methods: {
    onUserPercChange(item) {
      if (this.modal_message.messageModal === "bal") {
        item.hedge = (item.percentage / 100) * this.expoTotal;
      } else {
        item.hedge = (item.percentage / 100) * (item.balance + item.cashFlow);
      }
      this.localexampleData = JSON.parse(
        JSON.stringify(this.exampleDataFiltered),
      );
      this.calculateHedge();
    },
    calculateExpo() {
      if (this.modal_message.messageModal === "bal") {
        this.expoTotal = this.exampleData
          .map((d) => d.balance)
          .reduce((a, b) => a + b);
      } else {
        this.expoTotal = this.exampleData
          .map((d) => d.balance + d.cashFlow)
          .reduce((a, b) => a + b);
      }
    },
    calculateHedge() {
      if (this.modal_message.messageModal === "bal") {
        let vis = this;
        this.hedgeTotal = this.exampleDataFiltered
          .map((d) => (d.percentage / 100) * vis.expoTotal)
          .reduce((a, b) => a + b);
      } else {
        if (this.modal_message.optionsModal === "monthly") {
          this.hedgeTotal = this.exampleDataFiltered
            .map((d) => (d.percentage / 100) * (d.balance + d.cashFlow))
            .reduce((a, b) => a + b);
        } else {
          this.hedgeTotal = this.exampleDataFiltered
            .map((d) => ((3 * d.percentage) / 100) * (d.balance + d.cashFlow))
            .reduce((a, b) => a + b);
        }
      }
    },
    createPercentages() {
      if (this.modal_message.optionsModal === "monthly") {
        this.columnName = "MONTH";
        if (this.modal_message.messageModal === "bal") {
          let vis = this;
          this.percentTitle = "% OF BALANCE EXPO";
          this.exampleDataFiltered.forEach(
            (d) =>
              (d.percentage =
                Math.round((10000 * d.hedge) / vis.expoTotal) / 100),
          );
        } else {
          this.percentTitle = "% OF MONTHLY EXPO";
          this.exampleDataFiltered.forEach(
            (d) =>
              (d.percentage =
                Math.round((10000 * d.hedge) / (d.balance + d.cashFlow)) / 100),
          );
        }
      } else {
        let vis = this;
        this.columnName = "QUARTER";
        this.exampleDataFiltered = [];
        this.exampleData.forEach(function(d) {
          if (d.id % 3 === 0) {
            vis.exampleDataFiltered.push(d);
          }
        });
        if (this.modal_message.messageModal === "bal") {
          this.percentTitle = "% OF BALANCE EXPO";
          this.exampleDataFiltered.forEach(
            (d) =>
              (d.percentage =
                Math.round((10000 * d.hedge) / vis.expoTotal) / 100),
          );
        } else {
          this.percentTitle = "% OF QUARTERLY EXPO";
          // let idx;
          /*
          this.exampleDataFiltered.forEach(function(d, i) {
            idx = Math.floor(i / 3);
            d.percentage = Math.round(
              (100 * d.hedge) /
                (vis.exampleData[idx].balance +
                  vis.exampleData[idx].cashFlow +
                  vis.exampleData[idx + 1].balance +
                  vis.exampleData[idx + 1].cashFlow +
                  vis.exampleData[idx + 2].balance +
                  vis.exampleData[idx + 2].cashFlow)
            );
          });
*/
        }
      }
      this.calculateHedge();
    },
    updateHedge(data) {
      if (this.modal_message.messageModal === "bal") {
        data.forEach((d) => (d.hedge = (d.percentage / 100) * this.expoTotal));
      } else if (this.modal_message.optionsModal === "monthly") {
        data.forEach(
          (d) => (d.hedge = (d.percentage / 100) * (d.balance + d.cashFlow)),
        );
      } else {
        data.forEach(
          (d) =>
            (d.hedge = ((3 * d.percentage) / 100) * (d.balance + d.cashFlow)),
        );
      }
    },
    onUserAccept() {
      // let vis = this;
      if (Object.keys(this.localexampleData).length > 1) {
        this.exampleDataFiltered = this.localexampleData;
      }

      this.updateHedge(this.exampleDataFiltered);

      if (this.modal_message.optionsModal === "monthly") {
        this.$emit("eventOnUserAccept", this.exampleDataFiltered);
      } else {
        let perc = this.exampleDataFiltered.map((d) => d.hedge);
        this.exampleData.forEach(function(d, i) {
          d.hedge = perc[Math.floor(i / 3)] / 3;
        });
        this.$emit("eventOnUserAccept", this.exampleData);
      }
      this.exampleData = [];
      this.modal_message.showModalTailored = !this.modal_message
        .showModalTailored;
    },
  },
};
</script>

<style scoped>
input {
  display: inline-block;
  border-radius: 0;
  text-align: center;
}
input[type="number"] {
  text-align: center;
}
input[type="date"] {
  text-align: center;
}
</style>
